module.exports = __webpack_public_path__ + "static/modesta-bc-08-100be5f154b9bb5020b14b448879eb6c.png";